var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-waiting-modal-component" }, [
    _c("div", { staticClass: "room-waiting-modal" }, [
      _c(
        "div",
        { staticClass: "room-waiting-header" },
        [
          _c("div", { staticClass: "room-waiting-title" }, [
            _vm._v(_vm._s(_vm.$t("waitingRoom.list.title"))),
          ]),
          _c("GrmCloseBtn", { on: { click: _vm.onClose } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "room-waiting-body" },
        [_c("RoomWaitingTable")],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }